import { FormItem } from '../../../../../commons/Form/Form.types';
import { RegisterUserStepFormSchema } from './RegisterUserStepForm.types';

export const registerUserStepData: FormItem<RegisterUserStepFormSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'phone',
      placeholder: 'Votre numéro de téléphone...',
      label: 'Téléphone',
      type: 'tel',
      required: true,
    },
  ],
  [
    {
      name: 'function',
      placeholder: 'Votre fonction...',
      label: 'Fonction',
      type: 'text',
      required: true,
    },
  ],
];
